<template>
	<div class="infor fl">
		<AllHeader  :label="lable" :ischage="step&&step!=3" :sublabel="sublabel" @getvalue="getvalue" />
		<div v-if="!step">
			<el-table :data="list" :header-cell-style="{background:'#FEF8EF',color:'#7C828A'}"
				style="width: 100%;margin-top: 30px">
				<el-table-column prop="created_at" label="缴费时间" min-width="170">
				</el-table-column>
				<el-table-column prop="type" label="事项" min-width="120">
					<template slot-scope="scope">
						<div v-if="scope.row.is_invoice!=1">
							<span>申请发票</span>
						</div>
						<div v-else>
							<span>已申请</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column min-width="120" prop="amount" label="缴费金额">
					<template slot-scope="scope">
						<span>¥{{scope.row.amount}}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" width="140px" label="操作">
					<template slot-scope="scope">
						<div class="applybut" v-if="scope.row.is_invoice!=1" @click="getapply(scope.row)">
							<span>申请发票</span>
						</div>
						<div class="plybut" v-else>
							<span>已申请</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
		</div>
		<div v-if="step==1||step==3">
			<el-table :data="currItem" :header-cell-style="{background:'#F5F9FB',color:'#7C828A'}"
				style="width: 100%;margin-top: 30px">
				<el-table-column prop="created_at" label="缴费时间" min-width="170">
				</el-table-column>
				<el-table-column prop="type" label="事项" min-width="120">
					<template slot-scope="scope">
						<div v-if="scope.row.is_invoice!=1">
							<span>申请发票</span>
						</div>
						<div v-else>
							<span>已申请</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column min-width="120" prop="price" label="缴费金额">
					<template slot-scope="scope">
						<span>¥{{scope.row.amount}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="step==1" class="block-form">
				<p class="form-text">请选择需要开具的发票类型</p>
				<el-form ref="form" :model="form" class="flex-w">
					<el-form-item>
						<el-radio-group v-model="form.resource" size="medium" class="font-radio">
							<el-radio label="1">普通发票</el-radio>
							<el-radio label="2">专用发票</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div class="block-submit" @click="onNextTap">下一步</div>
			</div>
			<div v-if="step==3" class="block-status">
				<img src="../assets/failesucee.png" />
				<p class="font-size-20 margin-top-18">申请已经提交</p>
				<p class="font-assist margin-top-7">我们将尽快将电子发票发往您指定的邮箱，请耐心等待</p>
				<div class="block-return" @click="onReturnTap">返回缴费记录</div>
			</div>
		</div>
		<div v-if="step==2">
			<InvoiceFrom :step="step" :resource="form.resource" :currItem="currItem" @changeStep="submit"></InvoiceFrom>

		</div>
	</div>
</template>

<script>
	import AllHeader from "@/components/Modal/AllHeader";
	import Pagetion from "@/components/Modal/Pagetion";
	import InvoiceFrom from "@/components/Modal/InvoiceFrom";
	import {
		Order
	} from "../utils/api.js"
	export default {
		name: "record",
		components: {
			AllHeader,
			Pagetion,
			InvoiceFrom,
		},
		data() {
			return {
				lable: '',
				total: 0,
				addShow: false,
				sublabel: '取消并返回',
				step: 0,
				form: {
					resource: ''
				},
				list: [], //缴费记录列表
				currItem: [], //当前缴费的数据
			}
		},
		mounted() {
			this.lable = this.$route.query.name;
			this.initList(1)
		},
		methods: {
			initList(page) {
				const data = {
					page_size: 10,
					page: page,
				}
				Order(data).then(res => {
					if (res.data.length) {
						this.list = res.data
						this.total = res.total
					}

				})
			},
			getpageValue(index) {
				console.log(index)
				this.initList(index)
			},
			// 申请发票
			getapply(row) {
				console.log(row)
				this.step = 1
				this.lable = `申请发票${this.step}/3`
				this.currItem[0] = row
			},
			getvalue() {
				this.step = this.step - 1
				if (this.step) {
					this.lable = `申请发票${this.step}/3`
				} else {
					this.lable = this.$route.query.name;
				}
			},
			// 下一步
			onNextTap() {
				if (this.form.resource) {
					this.step = 2
					this.lable = `申请发票${this.step}/3`
				} else {
					this.$alert('请选择发票类型', '提示', {
						confirmButtonText: '确定',
					});
				}
			},
			// 提交
			submit(e) {
				this.step = e
				this.lable = `申请发票${this.step}/3`

			},
			// 返回缴费记录
			onReturnTap() {
				this.step = 0
				this.initList(1)

			}
		}
	}
</script>

<style scoped>
	.infor {}

	.block-form {
		margin-top: 93px;
		display: flex;
		flex-direction: column;
		align-items: center;

	}

	.flex-w {
		display: flex;
		justify-content: center;
		align-items: center;


	}

	.form-text {
		font-weight: bold;
		font-size: 18px;
		padding-bottom: 31px;
	}

	/deep/.el-radio-button__inner,
	.el-radio-group {
		display: flex;
		justify-content: center;
	}

	/deep/.el-radio {
		color: #71767C;
		cursor: pointer;
		margin-right: 0px;
	}

	/deep/.el-radio__input.is-checked .el-radio__inner {
		border-color: #194ABE;
		background: #194ABE;
	}

	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #0C0D0F;
	}

	/deep/.el-radio {
		color: #71767C;
		cursor: pointer;
		margin-right: 30px;
	}

	.block-submit {
		width: 156px;
		height: 50px;
		background: #FFFFFF !important;
		border: 1px solid #194ABE;
		opacity: 1;
		border-radius: 4px;
		color: #194ABE;
		font-size: 18px;
		font-weight: bold;
		line-height: 50px;
		text-align: center;
		margin-top: 30px;
		cursor: pointer;
	}

	.block-status {
		margin-top: 60px;

	}

	.margin-top-18 {
		margin-top: 18px;
	}

	.margin-top-7 {
		margin-top: 7px;
	}

	.block-return {
		width: 124px;
		height: 36px;
		line-height: 36px;
		background: #FFFFFF;
		border: 1px solid #194ABE;
		opacity: 1;
		border-radius: 6px;
		text-align: center;
		align-items: center;
		color: #194ABE;
		font-size: 16px;
		margin: 0 auto;
		margin-top: 38px;
	}
</style>
